import { createTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { Calendar, momentLocalizer } from "react-big-calendar";
import 'react-big-calendar/lib/css/react-big-calendar.css'
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ConflictoDialog from "../agenda/dialogs/ConflictoDialog";
import { ConflictoAgenda, comprobaciones, leerConflicto, sinConfirmaciones } from "../../utils/Disponibilidad";
import moment, { Moment } from "moment";
import { aDateOInvalida, esFechaValida } from "../../utils/FechaSelector";
import ILog from '../../types/Log';
import IEvent from "../../types/Event";
import LogService from '../../services/LogService';
import { Alert, Button, Checkbox, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, ListItemButton, Menu, MenuItem, Paper, Snackbar, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import * as constantes from "../../common/Constantes";
import AgendaService from '../../services/AgendaService';
import FilterOn from '@mui/icons-material/FilterList';
import FilterOff from '@mui/icons-material/FilterListOff';
import IPaciente from '../../types/Paciente';
import IMasterClass from '../../types/MasterClass';
import IClass from '../../types/Class';
import PacienteService from '../../services/PacienteService';
import PacientesUtils from '../../utils/Pacientes';
import EditActivities from './EditActivities';
import SelectorClases from './SelectorClases';
import ClaseUtils from '../../utils/Clase';
import { isMobile } from "react-device-detect";
import ConfigUtils from '../../utils/Config';
import IAlert from '../../types/Alert';
import ISala from '../../types/Sala';
import IActividad from '../../types/Actividad';
import IHoliday from '../../types/Holiday';
import WavesIcon from '@mui/icons-material/Waves';
import LandscapeIcon from '@mui/icons-material/Landscape';
import DiamondIcon from '@mui/icons-material/Diamond';
import GrassIcon from '@mui/icons-material/Grass';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PacienteActivities from './PacienteActivities';
import ListaEspera from './ListaEspera';
import AgendaUtils from '../../utils/Agenda';
import FacturacionClase from '../facturacion/facturarClase/FacturacionClase';
import FacturacionMes from '../facturacion/facturarClase/FacturacionMes';
import IServicio from '../../types/Servicio';
import IMetodoPago from '../../types/MetodoPago';

const locale = constantes.locale;

const AgendaAct = () => {
    const theme = createTheme();
    // Móvil: los diálogos grandes de la sección ocupan toda la pantalla para poder trabajar con todo el ancho
    const pantallaMovil = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useNavigate();
    const localizer = momentLocalizer(moment);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const [loading, setLoading] = useState(true);
    const [alert, setAlert] = useState<IAlert>({ open: false, severity: 'info', msg: '' });
    const [events, setEvents] = useState<Array<IEvent>>([]);
    const [shownEvents, setShownEvents] = useState<Array<IEvent>>([]);

    const [salas] = useState<Array<ISala>>(ConfigUtils.getSalas());
    const [actividades] = useState<Array<IActividad>>(ConfigUtils.getActividades());
    const [holidays, setHolidays] = useState<Array<IHoliday>>(ConfigUtils.getHolidays());

    const [sanitarios] = useState(ConfigUtils.getSanitarios());
    // No disponible del profesional o sala ocupada al crear clases: se pregunta y, si se confirma, se reenvía sin esa
    // comprobación.
    const [conflicto, setConflicto] = useState<ConflictoAgenda | null>(null);
    const confirmaciones = useRef(sinConfirmaciones());
    const [checkedSanitariosMap, setCheckedSanitariosMap] = useState<Record<string, boolean>>({});
    const [checkedActividadesMap, setCheckedActividadesMap] = useState<Record<string, boolean>>({});
    const [showFilters, setShowFilters] = useState(false);

    const [pacientes, setPacientes] = useState<Array<IPaciente>>([]);

    const [modalClass, setModalClass] = useState(false);
    const [loadingClass, setLoadingClass] = useState(false);
    const [actividadId, setActividadId] = useState<number>(0);
    const [especialistaId, setEspecialistaId] = useState<number>(0);
    const [startClass, setStartClass] = useState<Date>(new Date());
    const [duracion, setDuracion] = useState<number>(actividades[0]?.duracion);
    const [endClass, setEndClass] = useState<Date>(new Date());
    const [startClassTime, setStartClassTime] = useState<Date>(new Date(new Date().setMinutes(0)));
    const [weekDays, setWeekDays] = useState<Array<number>>([]);
    const [errorDiasSemana, setErrorDiasSemana] = useState<string>('');
    const [errorSala, setErrorSala] = useState(false);

    const salaDefault = ConfigUtils.getSalaByActividad(salas, actividades[0]);
    const [salaId, setSalaId] = useState<number>(salaDefault ? parseInt(salaDefault) : 0);

    const [masterClasses, setMasterClasses] = useState<Array<IMasterClass>>([]);
    const [masterClass, setMasterClass] = useState<IMasterClass>();
    const [selectedEvent, setSelectedEvent] = useState<IEvent>();

    const [modalDelete, setModalDelete] = useState(false);
    const [deleteChecked, setDeleteChecked] = useState<Array<string>>([]);
    const [modalConfirm, setModalConfirm] = useState(false);

    const [modalClassEvent, setModalClassEvent] = useState(false);

    const [modalEdit, setModalEdit] = useState(false);
    const [modalEditPacientes, setModalEditPacientes] = useState(false);
    // Clases elegidas desde la ficha de una clase (ella o ella y su pareja); sin valor, la edición empieza eligiendo clases
    const [masterIdsEdicion, setMasterIdsEdicion] = useState<string[] | undefined>(undefined);

    const [modalListaEspera, setModalListaEspera] = useState(false);
    const [modalFacturacion, setModalFacturacion] = useState(false);

    const servicios: IServicio[] = useMemo(() => ConfigUtils.getServicios(), []);
    const metodosPago: IMetodoPago[] = useMemo(() => ConfigUtils.getMetodosPago(), []);

    const userRole: number = ConfigUtils.getUserRole();

    const agendaConfig = ConfigUtils.getConfigAgenda();

    const minTime = useMemo(() => {
      const d = new Date();
      d.setHours(agendaConfig?.workingHours?.start ?? 8, 0, 0);
      return d;
    }, []);
    
    const maxTime = useMemo(() => {
      const d = new Date();
      d.setHours(agendaConfig?.workingHours?.end ?? 22, 0, 0);
      return d;
    }, []);

    // Fechas de las sesiones de cada clase recurrente, ordenadas: para mostrar su primera clase real (sin festivos)
    const sesionesPorClase = useMemo(() => {
        const mapa: Record<string, Date[]> = {};
        events.forEach(ev => {
            const repId = ev.resource?.repId;
            if (!repId) return;
            if (!mapa[repId]) mapa[repId] = [];
            mapa[repId].push(new Date(ev.start));
        });
        Object.values(mapa).forEach(fechas => fechas.sort((a, b) => a.getTime() - b.getTime()));
        return mapa;
    }, [events]);

    // Sesiones y clases recurrentes en el calendario. La ficha abierta, si la hay, se actualiza con los datos nuevos.
    const aplicarClases = useCallback((clasesData: IClass[], mastersData: IMasterClass[]) => {
        const classes = ClaseUtils.formatClassesActividades(clasesData, mastersData, actividades);

        classes.sort((a, b) => {
            if (a.resource.especialista < b.resource.especialista) return -1;
            if (a.resource.especialista > b.resource.especialista) return 1;
            return 0;
        });

        setEvents(classes);
        setShownEvents(classes);
        const orderedMasterClasses = mastersData
                                        .sort((a: IMasterClass, b: IMasterClass) => new Date(a.start).getHours() < new Date(b.start).getHours() ? -1 : 1)
                                        .sort((a: IMasterClass, b: IMasterClass) => a.weekDay - b.weekDay)
                                        .sort((a: IMasterClass, b: IMasterClass) => parseInt(a.title) - parseInt(b.title));
        // Las actividades programadas cuya actividad no está en la configuración no se muestran (ni se pueden editar)
        const masters = ClaseUtils.filtrarMastersConActividad(orderedMasterClasses, actividades, 'AgendaAct.Component');
        setMasterClasses(masters);
        setMasterClass(prev => prev ? masters.find(m => m._id === prev._id) ?? prev : prev);
        setSelectedEvent(prev => prev ? classes.find(e => e.id === prev.id) ?? prev : prev);
    }, [actividades]);

    useEffect(() => {

        const currentHolidays = AgendaUtils.fillMissingYearsHolidays(holidays, ConfigUtils.getProvincia());
        if (currentHolidays !== holidays) {
            setHolidays(currentHolidays);
        }

        const promisePacientes = PacienteService.getAll();
        const promiseClasses = AgendaService.getAllClasses();
        const promiseMasterClasses = AgendaService.getMasterClasses();
        Promise.all([promisePacientes, promiseClasses, promiseMasterClasses])

            .then((response) => {
                aplicarClases(response[1].data, response[2].data);
                const res = PacientesUtils.sortPacientesAlphabetically(response[0].data);
                setPacientes(res);
            })
            .catch((e) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'AgendaAct.Component.useEffect', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, [setAlert, history, actividades, holidays, aplicarClases]);

    // Tras guardar un cambio en las clases: se vuelven a pedir sesiones y clases, sin recargar la aplicación
    const recargarClases = useCallback(() => {
        Promise.all([AgendaService.getAllClasses(), AgendaService.getMasterClasses()])
            .then(([clases, masters]) => aplicarClases(clases.data, masters.data))
            .catch((e) => {
                if (e.response?.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'AgendaAct.Component.recargarClases', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response?.data?.message || 'Error al cargar las clases' });
                }
            });
    }, [aplicarClases, history]);

    // Tras guardar: las clases que devuelve la API se aplican en el momento (para que un segundo cambio parta de los datos
    // nuevos) y después se recarga todo para el calendario
    const edicionGuardada = (actualizadas?: IMasterClass[]) => {
        if (actualizadas && actualizadas.length > 0) {
            const nueva = (m: IMasterClass) => actualizadas.find(u => u._id === m._id) ?? m;
            setMasterClasses(prev => prev.map(nueva));
            setMasterClass(prev => prev ? nueva(prev) : prev);
        }
        setAlert({ open: true, severity: 'success', msg: 'Clases actualizadas correctamente' });
        recargarClases();
    };

    const applyFilters = useCallback(() => {
      if (!events.length) {
        setShownEvents([]);
        return;
      }

      let filteredEvents: IEvent[] = [];

      events.forEach((ev) => {
        const especialistaId = ev.resource?.especialista?.toString();
        const actividadTitle = ev.title.split(" [")[0];

        // Filtrado por sanitario
        if (especialistaId && checkedSanitariosMap[especialistaId] === false) {
          return; // este sanitario está desmarcado
        }

        // Filtrado por actividad
        if (actividadTitle && checkedActividadesMap[actividadTitle] === false) {
          return; // esta actividad está desmarcada
        }

        filteredEvents.push(ev);
      });

      // Evitar duplicados por id (por si acaso)
      const unique = Array.from(new Map(filteredEvents.map(ev => [ev.id, ev])).values());
      setShownEvents(unique);
    }, [events, checkedSanitariosMap, checkedActividadesMap, sanitarios, actividades]);

    useEffect(() => {
        applyFilters();
    }, [applyFilters]);

    // Sanitarios
    useEffect(() => {
      const active = sanitarios.filter(s => s.activo === true);
      const initial: Record<string, boolean> = {};
      active.forEach(s => {
        initial[s.internalID.toString()] = true;
      });

      setCheckedSanitariosMap(prev => {
        // preserva selecciones previas para sanitarios que siguen existiendo
        const merged = { ...initial };
        Object.keys(prev).forEach(k => {
          if (k in merged) merged[k] = prev[k];
        });
        return merged;
      });
    }, [sanitarios]);

    // Actividades
    useEffect(() => {
      const initial: Record<string, boolean> = {};
      actividades.forEach(a => {
        initial[a.title] = true;
      });

      setCheckedActividadesMap(prev => {
        // preserva selecciones previas para actividades que siguen existiendo
        const merged = { ...initial };
        Object.keys(prev).forEach(k => {
          if (k in merged) merged[k] = prev[k];
        });
        return merged;
      });
    }, [actividades]);

    // Resumen de «Nueva clase»: cuántas sesiones se crearán (sin los festivos que conoce la pantalla). weekDay: 0 = lunes.
    // null si aún faltan datos o si no cuadran: los avisos salen al pulsar «Crear clase», no antes.
    const resumenNuevaClase = (): string | null => {
        if (weekDays.length === 0 || !esFechaValida(startClass) || !esFechaValida(endClass) || !esFechaValida(startClassTime)) return null;
        const inicio = moment(startClass).startOf('day');
        const fin = moment(endClass).startOf('day');
        if (fin.isBefore(inicio)) return null;

        const festivos = ConfigUtils.formatEvents(holidays);
        const diasConClase = new Set<number>();
        let total = 0;
        for (const dia = inicio.clone(); dia.isSameOrBefore(fin, 'day'); dia.add(1, 'day')) {
            const weekDay = (dia.day() + 6) % 7;
            if (!weekDays.includes(weekDay)) continue;
            diasConClase.add(weekDay);
            if (!festivos.some(f => ConfigUtils.isSameLocalDay(new Date(f.start), dia.toDate()))) total++;
        }

        const nombres = (dias: number[]) => {
            const lista = [...dias].sort((a, b) => a - b).map(d => {
                const nombre = constantes.weekNames[d].toLowerCase();
                return nombre.endsWith('s') ? nombre : `${nombre}s`;
            });
            return lista.length > 1 ? `${lista.slice(0, -1).join(', ')} y ${lista[lista.length - 1]}` : lista[0];
        };
        if (weekDays.some(d => !diasConClase.has(d)) || total === 0) return null;

        const horas = `de ${moment(startClassTime).format('H:mm')} a ${moment(startClassTime).add(duracion, 'minutes').format('H:mm')}`;
        // Clase puntual (un solo día): «el lunes 02/11/2026 de 18:00 a 19:00»
        if (fin.isSame(inicio, 'day')) {
            return `Se creará 1 clase: el ${constantes.weekNames[(inicio.day() + 6) % 7].toLowerCase()} ${inicio.format('DD/MM/YYYY')} ${horas}`;
        }
        const periodo = `del ${inicio.format('DD/MM/YYYY')} al ${fin.format('DD/MM/YYYY')}`;
        return `Se ${total === 1 ? 'creará 1 clase' : `crearán ${total} clases`}: ${nombres(weekDays)} ${horas}, ${periodo} (sin festivos)`;
    };

    const closeModalClass = () => {
        setActividadId(0);
        setEspecialistaId(0);
        setStartClass(new Date());
        setStartClassTime(new Date(new Date().setMinutes(0)));
        setDuracion(actividades[0].duracion);
        setEndClass(new Date());
        setWeekDays([]);
        setErrorDiasSemana('');
        setErrorSala(false);
        setModalClass(false);
        const result = ConfigUtils.getSalaByActividad(salas, actividades[0]);
        if (result === undefined) return;
        setSalaId(parseInt(result));
    };

    const closeModalDelete = () => {
        setModalDelete(false);
        setDeleteChecked([]);
        setModalConfirm(false);
    };

    const saveClass = () => {
        setLoadingClass(true);
        if (weekDays.length === 0) {
            setErrorDiasSemana('Selecciona al menos un día de la semana *');
            setLoadingClass(false);
            return;
        }
        if (isNaN(salaId)) {
            setErrorSala(true);
            setLoadingClass(false);
            return;
        }
        setErrorDiasSemana('');
        setErrorSala(false);

        // Fechas u hora vacías o a medio escribir, o el fin antes del inicio: no se envía (llegaban a la API como null)
        if (!esFechaValida(startClass) || !esFechaValida(endClass) || !esFechaValida(startClassTime)) {
            setAlert({ open: true, severity: 'warning', msg: 'Indica una fecha de inicio, una fecha final y una hora de inicio válidas' });
            setLoadingClass(false);
            return;
        }
        if (moment(endClass).startOf('day').isBefore(moment(startClass).startOf('day'))) {
            setAlert({ open: true, severity: 'warning', msg: 'La fecha final debe ser igual o posterior a la de inicio' });
            setLoadingClass(false);
            return;
        }
        // Cada día elegido tiene que caer al menos una vez entre las fechas (si no, se crearía una clase vacía). weekDay: 0 = lunes
        const sinClase = weekDays.filter(weekDay => {
            for (const dia = moment(startClass).startOf('day'); dia.isSameOrBefore(moment(endClass), 'day'); dia.add(1, 'day')) {
                if ((dia.day() + 6) % 7 === weekDay) return false;
            }
            return true;
        });
        if (sinClase.length > 0) {
            setAlert({ open: true, severity: 'warning', msg: `No hay ningún ${sinClase.map(d => constantes.weekNames[d].toLowerCase()).join(' ni ')} entre esas fechas` });
            setLoadingClass(false);
            return;
        }

        const start = new Date(startClass);
        start.setHours(new Date(startClassTime).getHours());
        start.setMinutes(new Date(startClassTime).getMinutes());

        const newMasterClasses: IMasterClass[] = [];
        weekDays.map((weekDay) => {
            const newMasterClass: IMasterClass = {
                title: actividadId.toString(),
                especialistaId,
                salaId,
                start,
                duracion,
                terminarRepetir: endClass,
                weekDay: weekDay,
                userId: ConfigUtils.getUserId(),
                pacientes: []
            };
            newMasterClasses.push(newMasterClass);
            return newMasterClass;
        });

        let preguntar = false;
        AgendaService.createClasses(newMasterClasses, comprobaciones(confirmaciones.current))
            .then((response: any) => {
                confirmaciones.current = sinConfirmaciones();
                setModalClass(false);
                const createdClasses = ClaseUtils.formatClassesActividades(response.data[0], response.data[1], actividades);
                setEvents([...events, ...createdClasses]);
                setShownEvents([...events, ...createdClasses]);
                const orderedMasterClasses = [...masterClasses, ...response.data[1]].sort((a: IMasterClass, b: IMasterClass) => new Date(a.start).getDate() < new Date(b.start).getDate() ? 1 : -1).sort((a: IMasterClass, b: IMasterClass) => a.weekDay - b.weekDay)
                // Las actividades programadas cuya actividad no está en la configuración no se muestran (ni se pueden editar)
                setMasterClasses(ClaseUtils.filtrarMastersConActividad(orderedMasterClasses, actividades, 'AgendaAct.Component'));
                resetFilters();
                setAlert({ open: true, severity: 'success', msg: 'Clases creadas correctamente' });
            })
            .catch((e: any) => {
                if (e.response?.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else if (leerConflicto(e)) {
                    // Se pregunta con el formulario abierto, para poder reenviarlo tal cual
                    preguntar = true;
                    setConflicto(leerConflicto(e));
                } else if (e.response?.status === 400) {
                    // Validación de la API (profesional ocupado, etc.): se avisa, no es un error
                    confirmaciones.current = sinConfirmaciones();
                    setAlert({ open: true, severity: 'error', msg: e.response.data?.message || 'Error al crear las clases' });
                } else {
                    confirmaciones.current = sinConfirmaciones();
                    const error: ILog = { method: 'AgendaAct.Component.saveClass', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response?.data?.message || 'Error al crear las clases' });
                }
            })
            .finally(() => {
                setLoadingClass(false);
                if (!preguntar) closeModalClass();
            });
    };

    const selectClase = (event: IEvent) => {
        const selectedMasterClass: IMasterClass = masterClasses.filter(m => m._id === event.resource.repId)[0];
        if (selectedMasterClass === undefined) return;

        setMasterClass(selectedMasterClass);
        setSelectedEvent(event);
        setModalClassEvent(true);
    };

    const deleteClasses = () => {
        setModalConfirm(false);
        if (deleteChecked.length === 0) {
            setAlert({ open: true, severity: 'warning', msg: 'No se han seleccionado clases a eliminar' });
            return;
        }
        setLoadingClass(true);

        AgendaService.deleteClasses(deleteChecked)
            .then((response: any) => {
                let updatedEvents = events;
                for (let e of deleteChecked) {
                    updatedEvents = updatedEvents.filter(x => x.resource.repId !== e);
                }
                setEvents(updatedEvents);
                setShownEvents(updatedEvents);
                let updatedMasterClasses = masterClasses;
                for (let e of deleteChecked) {
                    updatedMasterClasses = updatedMasterClasses.filter(x => x._id !== e);
                }
                setMasterClasses(updatedMasterClasses);
                resetFilters();
                setAlert({ open: true, severity: 'success', msg: 'Clases eliminadas correctamente' });
                history(0);
            })
            .catch((e: any) => {
                if (e.response.status === 401) {
                    localStorage.clear();
                    history(constantes.R_HOME);
                } else {
                    const error: ILog = { method: 'AgendaAct.Component.deleteClasses', level: 'error', message: e.message, meta: e.response };
                    LogService.logError(error);
                    setAlert({ open: true, severity: 'error', msg: e.response.data.message });
                }
            })
            .finally(() => {
                setLoadingClass(false);
                closeModalDelete();
            })
    };

    const handleToggleSanitario = (internalID: number | string, checked: boolean) => {
        const id = internalID.toString();
        setCheckedSanitariosMap(prev => ({ ...prev, [id]: checked }));
    };

    const handleToggleActividad = (title: string, checked: boolean) => {
        setCheckedActividadesMap(prev => ({ ...prev, [title]: checked }));
    };

    const resetFilters = () => {
      // marcar todos los sanitarios activos
        const newSanitariosMap: Record<string, boolean> = {};
        sanitarios.filter(s => s.activo === true).forEach(s => {
            newSanitariosMap[s.internalID.toString()] = true;
        });
      setCheckedSanitariosMap(newSanitariosMap);
      // marcar todas las actividades activas
        const newActividadesMap: Record<string, boolean> = {};
        actividades.forEach(s => {
            newActividadesMap[s.title] = true;
        });
      setCheckedActividadesMap(newActividadesMap);
      setShowFilters(!showFilters);
    };

    const handleCloseAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlert({ open: false, severity: 'info', msg: '' });
    };

    const handleChangeActividad = (event: any) => {
        const actividad = actividades.filter(a => a.internalID == event.target.value)[0];
        setActividadId(parseInt(event.target.value));
        setDuracion(actividad.duracion);
        const result = ConfigUtils.getSalaByActividad(salas, actividad);
        if (result === undefined) return;
        setSalaId(parseInt(result));
    };

    const Event: React.FC<{ event: IEvent }> = ({ event }) => {
        const salaId = event?.resource?.sala;
        const sala = salas.find(s => s.internalID == salaId);
        let icon;
    
        if (sala != null) {
            // Asignar el ícono según el valor de sala.icon
            switch (sala.icon) {
                case "0":
                    icon = <WavesIcon sx={{ fontSize: '15px' }} />;
                    break;
                case "1":
                    icon = <DiamondIcon sx={{ fontSize: '15px' }} />;
                    break;
                case "2":
                    icon = <LandscapeIcon sx={{ fontSize: '15px' }} />;
                    break;
                case "3":
                    icon = <GrassIcon sx={{ fontSize: '15px' }} />;
                    break;
                case "4":
                    icon = <AcUnitIcon sx={{ fontSize: '15px' }} />;
                    break;
                default:
                    break;
            }
        }
    
        return (
            <div>
                {/* Primera línea: hora e ícono (si existe) */}
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap', whiteSpace: 'nowrap', overflow: 'hidden' }}>
                    <span style={{ fontSize: '80%', marginRight: '5px' }}>
                        {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
                    </span>
                    {icon && <span>{icon}</span>}
                </div>
                {/* Segunda línea: título del evento y, si no quedan plazas, «Completa» */}
                <div>
                    {event.title}
                    {event.resource?.capacidad > 0 && event.resource?.ocupados >= event.resource?.capacidad && (
                        <span style={{ marginLeft: 4, padding: '0 4px', borderRadius: 3, backgroundColor: '#fff', color: '#e65100', fontSize: '85%', fontWeight: 500, whiteSpace: 'nowrap' }}>Completa</span>
                    )}
                </div>
            </div>
        );
    };     
    
    const facturacion = servicios.length > 0 && metodosPago.length > 0;

    try {

        return (
            <>
                <Grid>
                    <Grid container>
                        <Container>
                            <Paper elevation={3} sx={{ marginTop: theme.spacing(2), padding: theme.spacing(1), marginBottom: theme.spacing(3) }}>
                                <Grid item md={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography variant="h4" sx={{ marginTop: theme.spacing(1), marginBottom: theme.spacing(1), fontWeight: 'bold' }}>CLASES</Typography>
                                </Grid>
                                <Grid item>
                                    {loading ? (
                                        <Grid container>
                                            <CircularProgress style={{ margin: '20px auto' }} />
                                        </Grid>
                                    ) : (
                                        <>
                                            <Grid container spacing={2} alignItems="center">
                                              <Grid item xs={12} sm="auto">
                                                <Button
                                                  fullWidth
                                                  variant="contained"
                                                  color="primary"
                                                  onClick={() => setModalClass(true)}
                                                  sx={{ minWidth: { xs: '100%', sm: 150 } }}
                                                >
                                                  NUEVA CLASE
                                                </Button>
                                              </Grid>

                                              {masterClasses.length > 0 && facturacion && (userRole === constantes.ROLES.ADMINISTRADOR || userRole === constantes.ROLES.SECRETARIO) && (
                                                <Grid item xs={12} sm="auto">
                                                  <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="secondary"
                                                    onClick={() => setModalFacturacion(true)}
                                                    sx={{ minWidth: { xs: '100%', sm: 170 } }}
                                                  >
                                                    FACTURACIÓN
                                                  </Button>
                                                </Grid>
                                              )}

                                              {masterClasses.length !== 0 && (
                                                <Grid item xs={12} sm="auto">
                                                  <IconButton
                                                    onClick={(e) => setAnchorEl(e.currentTarget)}
                                                    sx={{
                                                      border: '1px solid #ddd',
                                                      borderRadius: 2,
                                                      padding: {xs: 0, sm: 1},
                                                      width: { xs: '100%', sm: 'auto' },
                                                    }}
                                                  >
                                                    <MoreVertIcon />
                                                  </IconButton>
                                                
                                                  <Menu
                                                    anchorEl={anchorEl}
                                                    open={Boolean(anchorEl)}
                                                    onClose={() => setAnchorEl(null)}
                                                    PaperProps={{
                                                      sx: {
                                                        minWidth: 220,
                                                        padding: 1.5,
                                                        borderRadius: 2,
                                                        boxShadow: 3,
                                                        backgroundColor: '#fafafa',
                                                      }
                                                    }}
                                                  >
                                                    <ListItemButton onClick={() => { setModalEditPacientes(true); setAnchorEl(null); }}>
                                                      Modificar pacientes
                                                    </ListItemButton>
                                                
                                                    <ListItemButton onClick={() => { setModalEdit(true); setAnchorEl(null); }}>
                                                      Editar clases
                                                    </ListItemButton>
                                                
                                                    <ListItemButton onClick={() => { setModalListaEspera(true); setAnchorEl(null); }}>
                                                      Lista de espera
                                                    </ListItemButton>
                                                
                                                    {userRole === constantes.ROLES.ADMINISTRADOR && (
                                                      <ListItemButton
                                                        onClick={() => { setModalDelete(true); setAnchorEl(null); }}
                                                        sx={{ color: 'error.main' }}
                                                      >
                                                        Eliminar clases
                                                      </ListItemButton>
                                                    )}
                                                  </Menu>
                                                </Grid>
                                              )}

                                              {masterClasses.length === 0 && 
                                              <Grid item xs={12} sm="auto">
                                                <Button sx={{ minWidth: { xs: '100%', sm: 150 } }} onClick={() => { setModalListaEspera(true); setAnchorEl(null); }}>
                                                  LISTA DE ESPERA
                                                </Button>
                                              </Grid>}
                                            </Grid>
                                            {showFilters ? (
                                                <>
                                                    <Button sx={{ marginTop: theme.spacing(1) }} color="info" size="small" variant="contained" onClick={resetFilters} startIcon={<FilterOff />}>Quitar filtros</Button>
                                                    <FormGroup aria-label="position" row>
                                                        {actividades.map((actividad: IActividad) => {
                                                            return (
                                                            <FormControlLabel key={actividad.title} control={<Checkbox size={isMobile ? "small" : "medium"} checked={!!checkedActividadesMap[actividad.title]} inputProps={{ 'aria-label': 'controlled' }} />} label={actividad.title} onChange={(e, checked) => handleToggleActividad(actividad.title, checked)} />
                                                            );
                                                        })}
                                                        {sanitarios.filter(e => e.activo == true).map((empleado: any) => {
                                                            const id = empleado.internalID!.toString();
                                                            return (
                                                            <FormControlLabel key={empleado.internalID} control={<Checkbox size={isMobile ? "small" : "medium"} style={{ color: empleado.color }} checked={!!checkedSanitariosMap[id]} inputProps={{ 'aria-label': 'controlled' }} />} label={empleado.firstName} onChange={(e, checked) => handleToggleSanitario(empleado.internalID, checked)} />
                                                            );
                                                        })}
                                                    </FormGroup>
                                                </>
                                            ) : (
                                                <Button sx={{ marginBottom: theme.spacing(1), marginTop: theme.spacing(1) }} color="info" size="small" variant="contained" onClick={() => setShowFilters(!showFilters)} startIcon={<FilterOn />}>Mostrar filtros</Button>
                                            )}
                                            <style>
                                                {`
                                                    /* Oculta la hora del evento */
                                                    .rbc-event-label {
                                                        display: none;
                                                    }
                                                `}
                                            </style>
                                            <Calendar
                                                popup
                                                localizer={localizer}
                                                defaultView="work_week"
                                                views={['work_week']}
                                                events={shownEvents}
                                                min={minTime}
                                                max={maxTime}
                                                style={{ height: '95vh', fontSize: '12px', wordBreak: 'break-word' }}
                                                onSelectEvent={selectClase}
                                                components={{ event: Event }}
                                                messages={{
                                                    next: "Siguiente",
                                                    previous: "Anterior",
                                                    today: "Esta semana"
                                                }}
                                                eventPropGetter={(event: IEvent) => ({
                                                    style: {
                                                        backgroundColor: event.resource != null ? event.resource.especialista != null ? sanitarios.filter((s: any) => s.internalID === event.resource.especialista)[0]?.color : constantes.colorFestivos : '',
                                                        border: 'none',
                                                        textDecoration: event.title === 'CLASE ELIMINADA' ? 'line-through' : 'none'
                                                    }
                                                })}
                                                dayPropGetter={(day: Date) => ({
                                                    style: {
                                                        backgroundColor: ConfigUtils.formatEvents(holidays).some(festivo => ConfigUtils.isSameLocalDay(festivo.start, day)) ? constantes.colorBackgroundFestivos : 'transparent'
                                                    }
                                                })}
                                                dayLayoutAlgorithm={agendaConfig?.calendarLayout ?? 'no-overlap'}
                                            />
                                        </>
                                    )}
                                </Grid>
                            </Paper>
                        </Container>
                    </Grid>

                    {/* SELECCIONAR CLASE */}
                    {modalClassEvent && <FacturacionClase
                        open={modalClassEvent}
                        onClose={() => {setModalClassEvent(false); setMasterClass(undefined); setSelectedEvent(undefined)}}
                        masterClass={masterClass}
                        parejas={masterClass ? ClaseUtils.parejasDe(masterClass, masterClasses) : []}
                        selectedEvent={selectedEvent}
                        pacientes={pacientes}
                        facturacion={facturacion}
                        onModificarPacientes={(ids) => { setMasterIdsEdicion(ids); setModalEditPacientes(true); }}
                        onEditarClase={(ids) => { setMasterIdsEdicion(ids); setModalEdit(true); }}
                    />}
                    {/* AÑADIR CLASE */}
                    <Dialog open={modalClass} maxWidth="sm" fullWidth fullScreen={pantallaMovil} onClose={closeModalClass}>
                        <DialogTitle sx={{ pb: 0 }}>Nueva clase</DialogTitle>
                        <DialogContent>

                            {/* Qué */}
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>Qué</Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={4}>
                                    <TextField select value={actividadId} variant="outlined" label="Actividad" margin="dense" fullWidth required onChange={handleChangeActividad} >
                                    {
                                        actividades.map((actividad: any) => {
                                            return (
                                                <MenuItem key={actividad.internalID} value={actividad.internalID}>{actividad.title}</MenuItem>
                                            );
                                        })
                                    }
                                    </TextField>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <TextField select value={especialistaId} disabled={masterClass !== undefined} variant="outlined" label="Especialista" margin="dense" fullWidth required onChange={(event) => setEspecialistaId(parseInt(event.target.value))} >
                                        {
                                            sanitarios.filter(e => e.activo == true).map((empleado: any) => {
                                                return (
                                                    <MenuItem key={empleado.internalID} value={empleado.internalID}>{empleado.firstName}</MenuItem>
                                                );
                                            })
                                        }
                                    </TextField>
                                </Grid>
                                <Grid item xs={6} sm={4}>
                                    <TextField select value={salaId} disabled={masterClass !== undefined} variant="outlined" label="Sala" margin="dense" fullWidth required onChange={(event) => setSalaId(parseInt(event.target.value))} error={errorSala} helperText={errorSala ? "Selecciona la sala" : ""}>
                                        {
                                            salas.map((sala: any) => {
                                                return (
                                                    <MenuItem key={sala.internalID} value={sala.internalID}>{sala.title}</MenuItem>
                                                );
                                            })
                                        }
                                    </TextField>
                                </Grid>
                            </Grid>
                            {(() => {
                                const actividad = actividades.find(a => String(a.internalID) === String(actividadId));
                                return actividad?.capacity ? <Typography variant="caption" color="text.secondary">{`Aforo de ${actividad.title}: ${actividad.capacity} ${actividad.capacity === 1 ? 'plaza' : 'plazas'}`}</Typography> : null;
                            })()}

                            {/* Cuándo */}
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2, mb: 0.5 }}>Cuándo</Typography>
                            <ToggleButtonGroup
                                value={weekDays}
                                onChange={(_, dias: number[]) => { setWeekDays(dias); if (dias.length > 0) setErrorDiasSemana(''); }}
                                disabled={masterClass !== undefined}
                                size="small"
                                color="primary"
                                aria-label="Días de la semana"
                            >
                                {['L', 'M', 'X', 'J', 'V'].map((letra, dia) => (
                                    <ToggleButton key={dia} value={dia} aria-label={constantes.weekNames[dia]} sx={{ width: 40 }}>
                                        <Tooltip title={constantes.weekNames[dia]}><span>{letra}</span></Tooltip>
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                            {errorDiasSemana !== '' && <Typography variant="caption" color="error" sx={{ display: 'block' }}>Selecciona al menos un día de la semana</Typography>}
                            <Grid container spacing={1} sx={{ mt: 0.5 }}>
                                <Grid item xs={6}>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                                        <TimePicker disabled={masterClass !== undefined}
                                            renderInput={(props: any) => <TextField required fullWidth margin="dense" {...props} />}
                                            label="Hora de inicio"
                                            value={startClassTime}
                                            ampm={false}
                                            minutesStep={5}
                                            onChange={(date: Moment | null) => setStartClassTime(aDateOInvalida(date))}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField select value={duracion} disabled={masterClass !== undefined} variant="outlined" label="Duración" margin="dense" fullWidth required onChange={(event) => setDuracion(parseInt(event.target.value))} >
                                        {
                                            constantes.duracion.map((item, index) => {
                                                return (
                                                    <MenuItem key={index} value={item}>{`${item.toString()} minutos`}</MenuItem>
                                                );
                                            })
                                        }
                                    </TextField>
                                </Grid>
                            </Grid>
                            {esFechaValida(startClassTime) && (
                                <Typography variant="caption" color="text.secondary">
                                    {`De ${moment(startClassTime).format('H:mm')} a ${moment(startClassTime).add(duracion, 'minutes').format('H:mm')}`}
                                </Typography>
                            )}

                            {/* Periodo */}
                            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 2 }}>Periodo</Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                                        <DatePicker disabled={masterClass !== undefined}
                                            renderInput={(props: any) => <TextField required fullWidth margin="dense" {...props}
                                                helperText={esFechaValida(startClass) && moment(startClass).isBefore(moment(), 'day') ? `Se crearán también las clases ya pasadas desde el ${moment(startClass).format('DD/MM/YYYY')}` : undefined} />}
                                            label="Fecha de inicio"
                                            toolbarFormat="dd-mm-yyyy"
                                            value={startClass}
                                            onChange={(date: Moment | null) => setStartClass(aDateOInvalida(date))}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={locale}>
                                        <DatePicker disabled={masterClass !== undefined}
                                            renderInput={(props: any) => <TextField required fullWidth margin="dense" {...props} />}
                                            label="Fecha final"
                                            minDate={esFechaValida(startClass) ? moment(startClass) : undefined}
                                            toolbarFormat="dd-mm-yyyy"
                                            value={endClass}
                                            onChange={(date: Moment | null) => setEndClass(aDateOInvalida(date))}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </Grid>

                            {/* Qué se va a crear */}
                            {(() => {
                                const resumen = resumenNuevaClase();
                                return resumen ? <Alert severity="info" sx={{ mt: 2 }}>{resumen}</Alert> : null;
                            })()}
                        </DialogContent>
                        {loadingClass ?
                            <Grid container>
                                <CircularProgress style={{ margin: '20px auto' }} />
                            </Grid> :
                            <DialogActions>
                                <Button onClick={closeModalClass}>Cancelar</Button>
                                <Button variant="contained" onClick={saveClass}>Crear clase</Button>
                            </DialogActions>
                        }

                    </Dialog>
                    {/* QUÉ CLASE ELIMINAR */}
                    <Dialog open={modalDelete} maxWidth="md" fullWidth fullScreen={pantallaMovil} onClose={closeModalDelete}>
                        <DialogTitle sx={{ pb: 0 }}>Elige las clases a eliminar</DialogTitle>
                        <DialogContent>
                            <SelectorClases masterClasses={masterClasses} sesionesPorClase={sesionesPorClase} checked={deleteChecked} onChange={setDeleteChecked} />
                        </DialogContent>
                        {loadingClass ?
                            <Grid container>
                                <CircularProgress style={{ margin: '20px auto' }} />
                            </Grid> :
                            <DialogActions>
                                <Button color="error" onClick={() => {
                                    if (deleteChecked.length === 0) {
                                        setAlert({ open: true, severity: 'warning', msg: 'No se han seleccionado clases a eliminar' });
                                        return;
                                    } else {
                                        setModalConfirm(true);
                                    }}}
                                >
                                    {deleteChecked.length > 0 ? `Eliminar (${deleteChecked.length})` : 'Eliminar'}
                                </Button>
                                <Button onClick={closeModalDelete}>Cancelar</Button>
                            </DialogActions>
                        }
                    </Dialog>
                    {/* CONFIRMACION */}
                    <Dialog open={modalConfirm} maxWidth="sm" fullWidth onClose={closeModalDelete}>
                        <DialogTitle>{deleteChecked.length === 1 ? 'Eliminar 1 clase' : `Eliminar ${deleteChecked.length} clases`}</DialogTitle>
                        <>
                            <DialogContent>
                                {/* La API borra la clase y sus sesiones desde hoy; las ya dadas se quedan (salen como «CLASE ELIMINADA») */}
                                <DialogContentText sx={{ mb: 1 }}>
                                    Se eliminarán estas clases y todas sus sesiones a partir de hoy. Las sesiones ya dadas se conservan y en el calendario aparecen como «CLASE ELIMINADA».
                                </DialogContentText>
                                {
                                    deleteChecked.map((item) => {
                                        const clase = masterClasses.find(x => x._id === item);
                                        const actividad = clase && ClaseUtils.actividadDe(actividades, clase.title);
                                        return (clase === undefined || !actividad ? null : <p key={item}>{`${actividad.title} - ${ClaseUtils.formatClassTitle(clase)}`}</p>);
                                    })
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={closeModalDelete} autoFocus>Cancelar</Button>
                                <Button onClick={deleteClasses} color="error">Eliminar</Button>
                            </DialogActions>
                        </>
                    </Dialog>
                    {/* EDICIÓN DE CLASES */}
                    {modalEdit && <EditActivities masterClasses={masterClasses} sesionesPorClase={sesionesPorClase} masterIds={masterIdsEdicion} onClose={() => { setModalEdit(false); setMasterIdsEdicion(undefined); }} callBack={edicionGuardada} onError={(mensaje) => setAlert({ open: true, severity: 'error', msg: mensaje })} />}
                    {/* EDICIÓN DE PACIENTES EN LAS CLASES */}
                    {modalEditPacientes && <PacienteActivities masterClasses={masterClasses} sesionesPorClase={sesionesPorClase} masterIds={masterIdsEdicion} pacientes={pacientes} onClose={() => { setModalEditPacientes(false); setMasterIdsEdicion(undefined); }} callBack={edicionGuardada} onError={(mensaje) => setAlert({ open: true, severity: 'error', msg: mensaje })} /> }
                    {/* LISTA DE ESPERA */}
                    {modalListaEspera && <ListaEspera  masterClasses={masterClasses} pacientes={pacientes} onClose={() => setModalListaEspera(false)} callBack={() => { setAlert({ open: true, severity: 'success', msg: 'Paciente añadido correctamente' }) }} />}
                
                    {/* FACTURACIÓN */}
                    {modalFacturacion && 
                    <FacturacionMes 
                        open={modalFacturacion} 
                        onClose={() => setModalFacturacion(false)}
                        actividades={actividades}
                        masterClasses={masterClasses}
                        pacientes={pacientes}
                        sanitarios={sanitarios}
                    />}
                </Grid>

                {/* PROFESIONAL NO DISPONIBLE O SALA OCUPADA: ¿crear igualmente? */}
                <ConflictoDialog
                    conflicto={conflicto}
                    onConfirmar={() => {
                        if (conflicto) confirmaciones.current = { ...confirmaciones.current, [conflicto.tipo]: true };
                        setConflicto(null);
                        saveClass();
                    }}
                    onCancelar={() => { confirmaciones.current = sinConfirmaciones(); setConflicto(null); }}
                />

                <Snackbar open={alert.open} autoHideDuration={6000} onClose={handleCloseAlert}>
                    <Alert variant="filled" onClose={handleCloseAlert} severity={alert.severity} sx={{ width: '100%' }}>{alert.msg}</Alert>
                </Snackbar>
            </>
        );
    } catch (e: any) {
        const error: ILog = { method: 'AgendaAct.Component', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
        return (
            <Alert severity="error">{e.message}</Alert>
        );
    }

};

export default AgendaAct;